import { Component, OnInit, ViewChild } from '@angular/core';
import { PlatformLocation } from '@angular/common';

import { ModalDirective } from 'ng2-bootstrap';

import { Event, EventId } from '../../models/base/event';
import { WebMethodResult } from '../../models/web-method-result';

import { Query } from '../../models/query/query';
import { Company } from '../../models/lookups/company';
import { UserCalendar } from '../../models/lookups/user-calendar';
import { UserCalendarService } from '../../services/lookups/user-calendar.service';
import { Stockroom } from '../../models/stockroom/stockroom';
import { ClientSettingsService } from '../../services/settings/client-settings.service';
import { AppConfigurationService } from '../../services/base/app-configuration';
import { AppConfiguration } from '../../models/base/app_configuration';
import { BaseComponent } from '../base/base.component';
import { AppModulePath } from '../../models/app-module-path';
import { forkJoin, Observable, timer } from 'rxjs';
import { isNil } from 'lodash';
import { MenuItem } from 'primeng';
import { ActivatedRoute } from '@angular/router';

declare var $: any;

@Component({
  selector: 'bms-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent extends BaseComponent implements OnInit {

  public static APM: string;
  private chooseCompanyStockroomErrorMsg: string;

  activeCompany: Company;
  activeStockroom: Stockroom;
  afterLogin: boolean;
  activeUserId: number;
  username: string;
  appConfigurations: AppConfiguration[];
  public danas = new Date();
  public datum = new Date();
  appModulePath: typeof AppModulePath;
  //    private activities;

  calendarItems: UserCalendar[] = null;

  @ViewChild('chooseCSDialog', { static: false })
  private chooseCSDialog: ModalDirective;


  @ViewChild('chooseCompanyDialog', { static: false })
  private chooseCompanyDialog: ModalDirective;

  @ViewChild('newCalendarItem', { static: false })
  private newCalendarItem: ModalDirective;

  menuItems: MenuItem[] = [];

  constructor(private route: ActivatedRoute,
    private clientSettings: ClientSettingsService,
    //        private securityService: SecurityService,
    private appConfigurationService: AppConfigurationService,
    //        private router: Router,
    private platformLocation: PlatformLocation,
    private userCalendar: UserCalendarService) {
    super();
    this.appModulePath = AppModulePath;

    this.buildMenuItems();
  }

  listUserCalendarItems(): Observable<UserCalendar[]> {
    return this.userCalendar.listUserCalendarItems(new Query());
  }

  ngOnInit() {
    forkJoin([this.listUserCalendarItems(), this.getApmUrl()]).subscribe(data2 => {
      this.calendarItems = data2[0];
      this.appConfigurations = data2[1];
      if (!isNil(this.appConfigurations.find(appConf => appConf.id === 3))) {
        HomeComponent.APM = this.appConfigurations.find(appConf => appConf.id === 3).value;
      }
      const appType = this.appConfigurations.find(appConf => appConf.name === 'app_type');
      if (!isNil(appType)) {
        localStorage.setItem('appType', appType.value);
      }
    });
    this.translateSvc.use(this.securityService.loggedUser.uiLang);
    this.buildMenuItems();

    this.activeUserId = this.securityService.loggedUser.id;
    this.username = this.securityService.loggedUser.fullName();
    this.activeCompany = this.clientSettings.getActiveCompany();
    this.activeStockroom = this.clientSettings.getActiveStockroom();
    if ((isNil(this.activeCompany) || (!isNil(this.activeCompany) && isNil(this.activeCompany.id))) ||
      (isNil(this.activeStockroom) || (!isNil(this.activeStockroom) && isNil(this.activeStockroom.id)))) {
      this.afterLogin = true;

      timer(1000).subscribe(() => {
        if (!isNil(this.chooseCSDialog)) {
          this.chooseCSDialog.show();
        }
      });
    } else {
      this.clientSettings.setActiveCompany(this.activeCompany);
      this.clientSettings.setActiveStockroom(this.activeStockroom);
    }
    if (localStorage.getItem('currentUrl') !== null && localStorage.getItem('currentUrl') !== undefined) {
      this.router.navigateByUrl(localStorage.getItem('currentUrl'));
      localStorage.removeItem('currentUrl');
    }
    this.activities = this.securityService.getGrantedActivities();

    this.route.queryParams.subscribe(params => {
      if (params['openCS']) {
        timer(500).subscribe(() => {
          if (this.chooseCSDialog) {
            this.chooseCSDialog.show();
          }
        });
      }
    });
  }

  showChooseCSDialog() {
    this.afterLogin = false;
    this.chooseCSDialog.show();
  }

  showCompanyDialog() {
    this.chooseCompanyDialog.show();
  }

  onEvent(event: Event) {
    if (event.id === EventId.DIALOG_OK) {
      this.activeCompany = event.object.company;
      this.activeStockroom = event.object.stockroom;

      this.clientSettings.setActiveCompany(this.activeCompany);
      this.clientSettings.setActiveStockroom(this.activeStockroom);
    } else if (event.id === EventId.DIALOG_CANCEL && this.afterLogin) {
      this.displayErrorPage(this.chooseCompanyStockroomErrorMsg);
      // Niste izabrali ni kompaniju ni magacin!
      // this.router.navigate(['ng/error'], {
      //   queryParams: {
      //     errorObj: JSON.stringify(WebMethodResult.create(-1, 'Niste izabrali ni kompaniju ni magacin!'))
      //   }
      // });
    } else if (event.id === EventId.DIALOG_CANCEL) {
      if (!isNil(this.newCalendarItem)) {
        this.newCalendarItem.hide();
      }
    }
    this.chooseCSDialog.hide();
    this.chooseCompanyDialog.hide();
    this.initCalendar();
  }

  // preventClose() {
  //   $('a.prevent-close').on('click', function (e) {
  //     $(this).next('ul').toggle();
  //     e.stopPropagation();
  //     e.preventDefault();
  //   });
  // }

  getApmUrl(): Observable<AppConfiguration[]> {
    return this.appConfigurationService.list(new Query());
  }

  upravljanjeKorisnicima() {
    if (!!HomeComponent.APM) {
      window.open(HomeComponent.APM, '_blank');
    }
  }

  openAPMforUser() {
    if (!!HomeComponent.APM) {
      window.open(HomeComponent.APM + '/#/settings', '_blank');
    }
  }

  onLogout() {
    this.securityService.logout().subscribe(
      success => window.location.reload()
    );
  }

  private buildMenuItems(): void {
    const activeLang = this.securityService.loggedUser ? this.securityService.loggedUser.uiLang : 'sr-Latn';
    this.transl([
      'home.menu.logout',
      'home.menu.english',
      'home.menu.serbianLatin',
      'home.menu.serbianCyrillic',
      'home.errors.chooseCompanyAndStockroom'
    ]).subscribe(t => {
      this.chooseCompanyStockroomErrorMsg = t.homeErrorsChooseCompanyAndStockroom;
      this.menuItems = [
        {
          label: t.homeMenuLogout,
          icon: 'fa fa-sign-out',
          command: () => {
            this.onLogout();
          }
        },
        { label: '', separator: true },
        {
          label: t.homeMenuEnglish,
          styleClass: this.getLanguageMenuItemClass(activeLang, 'en'),
          command: () => {
            this.onLanguageChange('en');
          }
        },
        {
          label: t.homeMenuSerbianLatin,
          styleClass: this.getLanguageMenuItemClass(activeLang, 'sr-Latn'),
          command: () => {
            this.onLanguageChange('sr-Latn');
          }
        },
        {
          label: t.homeMenuSerbianCyrillic,
          styleClass: this.getLanguageMenuItemClass(activeLang, 'sr-Cyrl'),
          command: () => {
            this.onLanguageChange('sr-Cyrl');
          }
        }];
    });
  }

  private getLanguageMenuItemClass(activeLang: string, lang: string): string {
    return activeLang === lang ? 'user-menu-language user-menu-language-selected' : 'user-menu-language';
  }

  // #############################################
  initCalendar() {
    this.listUserCalendarItems().subscribe(data => {
      this.calendarItems = data;
    });
  }

  createDate(date, days, months, years) {
    if (!date) {
      date = new Date();
    }
    date.setDate(date.getDate() + days);
    date.setMonth(date.getMonth() + months);
    date.setFullYear(date.getFullYear() + years);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  nextMonth() {
    this.datum = this.createDate(this.datum, 0, 1, 0);
    console.log(this.datum);
  }

  prevMonth() {
    this.datum = this.createDate(this.datum, 0, -1, 0);
    console.log(this.datum);
  }

  nextYear() {
    this.datum = this.createDate(this.datum, 0, 0, 1);
    console.log(this.datum);
  }

  prevYear() {
    this.datum = this.createDate(this.datum, 0, 0, -1);
    console.log(this.datum);
  }

  range(a, b) {
    const arr = [];
    for (let i = a; i <= b; i++) {
      arr.push(i);
    }
    return arr;
  }

  maxDayOfMonth() {
    return new Date(this.datum.getFullYear(), this.datum.getMonth() + 1, 0).getDate();
  }

  firstDayOfMonth() {
    const dan = new Date(this.datum.getFullYear(), this.datum.getMonth(), 1).getDay();
    if (dan === 0) {
      return 7;
    } else {
      return dan;
    }
  }

  clickDay(dan) {
    this.datum.setDate(dan.innerHTML);
    this.newCalendarItem.show();
  }

  isActive(dan: number) {
    for (const item of this.calendarItems) {
      if (new Date(item.dateOfEvent).getDate() === dan && new Date(item.dateOfEvent).getMonth() === this.datum.getMonth() &&
        new Date(item.dateOfEvent).getFullYear() === this.datum.getFullYear()) {
        return true;
      }
    }
    return false;
  }

  pastDay(dan: number) {
    return dan < this.danas.getDate();
  }

  haveAllFinishedTasks(dan: number) {
    for (const item of this.calendarItems) {
      if (new Date(item.dateOfEvent).getDate() === dan && new Date(item.dateOfEvent).getMonth() === this.datum.getMonth() &&
        new Date(item.dateOfEvent).getFullYear() === this.datum.getFullYear()) {
        if (item.activity === 1) {
          return false;
        }
      }
    }
    return true;
  }

  private onLanguageChange(lang: string) {
    this.securityService.loggedUser.uiLang = lang;
    this.securityService.setLang(this.securityService.loggedUser.lang).subscribe({
      next: () => {
        this.translateSvc.use(lang);
        this.buildMenuItems();
      },
      error: (err) => {
        this.setError(err);
      }
    });
  }
}
